// extracted by mini-css-extract-plugin
export default {"landing-container":"Landing_landing-container__jsNKB","slogans":"Landing_slogans__zOScE","button":"Landing_button__jKSRs","contacts":"Landing_contacts__+G41A"};